import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Heading } from '@zillow/constellation';

import PaidInclusionActions from 'app/shared/actions/PaidInclusionActions';
import PaidInclusionPaymentModal from 'app/shared/containers/paidInclusion/PaymentModal';

import PaidInclusionSelectors from 'app/shared/selectors/PaidInclusionSelectors';
import { AppSelectors, UserSelectors } from 'app/shared/selectors';

class PaymentPage extends React.Component {
    componentDidMount() {
        const {
            dispatch,
            hostApp,
        } = this.props;

        const listing = this.getListingFromPathName();

        dispatch(PaidInclusionActions.details(listing.listingId));
        dispatch(PaidInclusionActions.verifyPaymentAndActivateListing(listing, true, false, hostApp));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isPaymentValid) {
            // payment success callback to mobile apps.
            window.ZRM_NATIVE_API.onPaidInclusionPaymentMade('success');
        }
    }

    getListingFromPathName() {
        const listingId = this.props.location.pathname.split('/')[3];

        return { listingId };
    }

    renderPaidInclusionPaymentModal() {
        const {
            user,
            hostApp,
            price,
            isEligibleForLeadGuarantee,
        } = this.props;

        const listing = this.getListingFromPathName();

        return (
            <div>
                <Heading level={6} className="PaymentPage-Title" />

                <PaidInclusionPaymentModal
                    listing={listing}
                    user={user}
                    isRenderedInPageView={true}
                    hostApp={hostApp}
                    price={price}
                    isEligibleForLeadGuarantee={isEligibleForLeadGuarantee}
                />
            </div>
        );
    }

    render() {
        return (
            <div style={{ marginLeft: '15px', marginRight: '15px', paddingBottom: '300px' }}>
                {this.renderPaidInclusionPaymentModal()}
            </div>
        );
    }
}

PaymentPage.propTypes = {
    price: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
    hostApp: AppSelectors.makeHostApp(state),
    user: UserSelectors.makeUser(state),
    isPaymentValid: PaidInclusionSelectors.makeIsPaymentValid(state),
    price: PaidInclusionSelectors.makePrice(state),
    isEligibleForLeadGuarantee: PaidInclusionSelectors.makeIsEligibleForLeadGuarantee(state),
});

export { PaymentPage };
export default connect(mapStateToProps)(PaymentPage);
